import type { SetupStepId } from '@shared/setup'
import { reminderBannerText, type CopyContext } from '../data/setup-copy'

/**
 * Non-modal reminder for required steps already put off as a popup (once if
 * the phone never asked, three times if blocked in Settings): shown on app
 * opens while they're still to do. "Fix" opens those steps.
 */
export function SetupReminderBanner({
  steps,
  platform,
  onFix,
  onHide,
}: {
  steps: readonly SetupStepId[]
  platform: CopyContext['platform']
  onFix: () => void
  onHide: () => void
}) {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[calc(var(--safe-top,0px)+0.5rem)] z-40 flex justify-center px-3">
      <div
        role="region"
        aria-label="Set up reminder"
        className="pointer-events-auto flex w-full max-w-md items-center gap-2 rounded-2xl border border-amber-200 bg-amber-50 px-3 py-2 shadow-md"
      >
        <span aria-hidden className="text-amber-700">
          ⚠
        </span>
        <p className="flex-1 text-sm font-medium text-amber-900">{reminderBannerText(steps, platform)}</p>
        <button
          type="button"
          onClick={onFix}
          className="min-h-11 rounded-xl bg-amber-600 px-3 text-sm font-semibold text-white outline-none hover:bg-amber-700 focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2"
        >
          Fix
        </button>
        <button
          type="button"
          onClick={onHide}
          aria-label="Hide this reminder for now"
          className="flex min-h-11 min-w-11 items-center justify-center rounded-xl text-amber-800 outline-none hover:bg-amber-100 focus-visible:ring-2 focus-visible:ring-amber-500"
        >
          <svg aria-hidden className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  )
}
